import L from "leaflet";

// Routes come from the API as already-parsed GeoJSON geometry (via
// ST_AsGeoJSON on the backend) — unlike layerCycleway/layerPointOfOrientation
// this doesn't fetch anything itself, it just renders data it's given.
export function addLayerRoute(map, routes, options = {}) {
  const { color = "#7a1200", weight = 3, pane = "routing" } = options;

  // featureGroup (not layerGroup) so MapView can zoom to its bounds
  const layer = L.featureGroup();

  routes.forEach((route) => {
    if (!route.geom) return;

    const routeLayer = L.geoJSON(route.geom, {
      style: () => ({ color, weight }),
      pane,
    });

    if (route.name) {
      routeLayer.bindTooltip(route.name, { sticky: true });
    }

    layer.addLayer(routeLayer);
  });

  layer.addTo(map);

  return layer;
}
